import { IIndicatorCategory } from "types/graphqlTypes";

export default function translateIndicatorCategory(category: IIndicatorCategory, languageCode: "pt" | "en") {
  const translations = {
    pt: {
      [IIndicatorCategory.BalanceSheet]: "Balanço Patrimonial",
      [IIndicatorCategory.CashFlow]: "Fluxo de Caixa",
      [IIndicatorCategory.Fundamentei]: "Fundamentei",
      [IIndicatorCategory.IncomeStatement]: "DRE",
      [IIndicatorCategory.Metrics]: "Métricas",
      [IIndicatorCategory.Other]: "Outros",
      [IIndicatorCategory.Payout]: "Pagamento",
      [IIndicatorCategory.Ratios]: "Índices",
    },
    en: {
      [IIndicatorCategory.BalanceSheet]: "Balance Sheet",
      [IIndicatorCategory.CashFlow]: "Cash Flow",
      [IIndicatorCategory.Fundamentei]: "Fundamentei",
      [IIndicatorCategory.IncomeStatement]: "Income Statement",
      [IIndicatorCategory.Metrics]: "Metrics",
      [IIndicatorCategory.Other]: "Other",
      [IIndicatorCategory.Payout]: "Payout",
      [IIndicatorCategory.Ratios]: "Ratios",
    },
  } as const;

  return translations[languageCode][category];
}
